import { api } from './client';
import type { UserDto } from './types';

export function getMe(): Promise<UserDto> {
  return api<UserDto>('/users/me');
}

export function patchPrefs(patch: Record<string, unknown>): Promise<Record<string, unknown>> {
  return api<Record<string, unknown>>('/users/me/prefs', { method: 'PATCH', body: patch });
}
